import { TransportType } from 'app/constants/transportType'

export const getTransportTypeName = (
  transportType: TransportType,
  translate: (string) => string,
): string => {
  const text: string = TransportType[transportType]
  return translate(`transportType.${text}`)
}
